module.exports = __webpack_public_path__ + "img/island-display.7270b0c1.png";